import { Skeleton } from '@components/atoms/Skeleton/Skeleton';

import { useResponsive } from '@utils/hooks/useResponsive';

import {
    MobileSkeletonHeader,
    SkeletonOptionWrapper,
    SkeletonWrapper,
} from './NotificationsList.styled';

const SKELETONS_NUMBER = 5;
const MD_SKELETONS_NUMBER = 8;

export const NotificationsListSkeleton = () => {
    const isMd = useResponsive('md');

    if (isMd)
        return (
            <div>
                {[...Array(MD_SKELETONS_NUMBER).keys()].map((key) => (
                    <SkeletonWrapper key={key}>
                        <MobileSkeletonHeader>
                            <Skeleton height={24} inline />
                        </MobileSkeletonHeader>
                        <Skeleton height={22} inline width={140} />
                    </SkeletonWrapper>
                ))}
            </div>
        );

    return (
        <div>
            {[...Array(SKELETONS_NUMBER).keys()].map((key) => (
                <SkeletonWrapper key={key}>
                    <SkeletonOptionWrapper>
                        <Skeleton height={24} inline />
                        <Skeleton height={24} inline />
                    </SkeletonOptionWrapper>
                    <Skeleton height={24} inline />
                </SkeletonWrapper>
            ))}
        </div>
    );
};
